export const company_industries = [
	{
		childTitle: 'Agriculture & AgriTech',
		childLink: '/agriculture',
	},
	{
		childTitle: 'Energy, Oil & Gas',
		childLink: '/energy',
	},
	{
		childTitle: 'Healthcare',
		childLink: '/healthcare',
	},
	{
		childTitle: 'Real Estate',
		childLink: '/realestate',
	},
];

export const company_profile = [
	{
		childTitle: 'Company Profile',
		childLink: '/companyprofile',
	},
	{
		childTitle: 'Our Network',
		childLink: '/network',
	},
];

export const company_team = [
	{
		childTitle: 'William Lau',
		childLink: '/#TheTeam',
	},
	{
		childTitle: 'Midori Aw',
		childLink: '/#TheTeam',
	},
];

export const contact_us = [{
	childTitle: 'Contact Us',
	childLink: '/#Footer',
}];
